import { fetchRequestWithTypes } from './index.js';

export const GET_ACTIVE_PLATFORM_TIER_REQUEST = 'GET_ACTIVE_PLATFORM_TIER_REQUEST';
export const GET_ACTIVE_PLATFORM_TIER_SUCCESS = 'GET_ACTIVE_PLATFORM_TIER_SUCCESS';
export const GET_ACTIVE_PLATFORM_TIER_ERRORED = 'GET_ACTIVE_PLATFORM_TIER_ERRORED';

export const getActivePlatformTier = () =>
	fetchRequestWithTypes({
		types: [
			GET_ACTIVE_PLATFORM_TIER_REQUEST,
			GET_ACTIVE_PLATFORM_TIER_SUCCESS,
			GET_ACTIVE_PLATFORM_TIER_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/concierge/api/v1/users/:uuid/platform_tiers/active_platform_tier`,
		},
	});

// Initiate canceling the tier of user and closing accounts if applicable
// https://edge.stsh.io/documentation/1.0/platform_tiers/cancel.html

export const PATCH_PLATFORM_TIER_CANCEL_REQUEST = 'PATCH_PLATFORM_TIER_CANCEL_REQUEST';
export const PATCH_PLATFORM_TIER_CANCEL_SUCCESS = 'PATCH_PLATFORM_TIER_CANCEL_SUCCESS';
export const PATCH_PLATFORM_TIER_CANCEL_ERRORED = 'PATCH_PLATFORM_TIER_CANCEL_ERRORED';

export const patchPlatformTierCancel = () => {
	return fetchRequestWithTypes({
		types: [
			PATCH_PLATFORM_TIER_CANCEL_REQUEST,
			PATCH_PLATFORM_TIER_CANCEL_SUCCESS,
			PATCH_PLATFORM_TIER_CANCEL_ERRORED,
		],
		request: {
			method: 'PATCH',
			path: '/apis/concierge/api/v1/users/:uuid/platform_tiers/cancel',
		},
	});
};

export const GET_MONTHLY_MARKET_REPORTS_REQUEST = 'GET_MONTHLY_MARKET_REPORTS_REQUEST';
export const GET_MONTHLY_MARKET_REPORTS_SUCCESS = 'GET_MONTHLY_MARKET_REPORTS_SUCCESS';
export const GET_MONTHLY_MARKET_REPORTS_ERRORED = 'GET_MONTHLY_MARKET_REPORTS_ERRORED';

export const getMonthlyMarketReports = () =>
	fetchRequestWithTypes({
		types: [
			GET_MONTHLY_MARKET_REPORTS_REQUEST,
			GET_MONTHLY_MARKET_REPORTS_SUCCESS,
			GET_MONTHLY_MARKET_REPORTS_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/apis/api/v1/users/:uuid/platform_tiers/monthly_market_reports',
		},
	});

export const GET_BILLING_SUMMARY_REQUEST = 'GET_BILLING_SUMMARY_REQUEST';
export const GET_BILLING_SUMMARY_SUCCESS = 'GET_BILLING_SUMMARY_SUCCESS';
export const GET_BILLING_SUMMARY_ERRORED = 'GET_BILLING_SUMMARY_ERRORED';

export const getBillingSummary = () => {
	return fetchRequestWithTypes({
		types: [
			GET_BILLING_SUMMARY_REQUEST,
			GET_BILLING_SUMMARY_SUCCESS,
			GET_BILLING_SUMMARY_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/apis/customers/v1/users/:uuid/subscriptions/invoicePreview',
		},
	});
};

export const GET_SUBSCRIPTION_ACTION_REQUEST = 'GET_SUBSCRIPTION_ACTION_REQUEST';
export const GET_SUBSCRIPTION_ACTION_SUCCESS = 'GET_SUBSCRIPTION_ACTION_SUCCESS';
export const GET_SUBSCRIPTION_ACTION_ERRORED = 'GET_SUBSCRIPTION_ACTION_ERRORED';

export const getSubscriptionActions = (action, state) => {
	return fetchRequestWithTypes({
		types: [
			GET_SUBSCRIPTION_ACTION_REQUEST,
			GET_SUBSCRIPTION_ACTION_SUCCESS,
			GET_SUBSCRIPTION_ACTION_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/concierge/api/v1/users/:uuid/subscriptionActions?subscriptionAction=${action}&state=${state}`,
		},
	});
};
